import React from 'react';
import { Button, PageTitle, CardTitle } from '@cordata/buffet';
import { useHistory, useParams, Link } from 'react-router-dom';
import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CardColumns as CareTeamColumns } from '~/components/CareTeam';
import { CardColumns as CareGiversColumns } from '~/components/CareGiver';

const PatientsCareTeamCollection = () => {
  const history = useHistory();
  const params = useParams();

  const onTeamClick = item =>
    history.push(`/patients/${params.patient_id}/care-team/${item.id}`);

  const onGiverClick = item =>
    history.push(`/patients/${params.patient_id}/care-givers/${item.id}`);

  return (
    <>
      <PageTitle
        action={
          <UncontrolledButtonDropdown size="sm" className="w-100">
            <Button
              outline
              tag={Link}
              to={`/patients/${params.patient_id}/care-team/add`}
              icon="plus"
            >
              Add Care Team Member
            </Button>

            <DropdownToggle caret outline />

            <DropdownMenu right>
              <DropdownItem
                tag={Link}
                to={`/patients/${params.patient_id}/care-givers/add`}
              >
                <FontAwesomeIcon icon="plus" fixedWidth />
                Add Care Giver
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        }
      >
        Care Team
      </PageTitle>

      <CareTeamColumns
        params={{
          patient_uid: params.patient_id,
        }}
        onClick={onTeamClick}
      />

      <CardTitle>Care Givers</CardTitle>

      <CareGiversColumns
        params={{
          patient_uid: params.patient_id,
        }}
        onClick={onGiverClick}
      />
    </>
  );
};

export default PatientsCareTeamCollection;
